module.exports = __webpack_public_path__ + "static/church-gathering-74ddcd52b868ec28d270b300a067018e.jpg";